import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * 日历组件
 */
const WEEK_NAMES = ['日', '一', '二', '三', '四', '五', '六'];
const LINES = [1, 2, 3, 4, 5, 6];

class Calendar extends React.PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
    };

    state = {
        month: 0,
        year: 0,
        currentDate: new Date(),
        currentYear: new Date().getFullYear(),
        currentYearMonth: new Date().getMonth(),
        currentDay: new Date().getDate(),
        days: 31,
        firstDay: 0,
    };

    static defaultProps = {
        onChange: () => {},
    };

    componentDidMount = () => {
        this.setCurrentYearMonth(this.state.currentDate);

        this.props.onChange(`${this.state.currentYear}-${this.state.currentYearMonth + 1}-${this.state.currentDay}`);
    };

    // 获取月份
    static getMonth(date) {
        return date.getMonth();
    }

    // 获取年份
    static getFullYear(date) {
        return date.getFullYear();
    }

    // 设置当前年月
    setCurrentYearMonth(date) {
        const month = Calendar.getMonth(date);
        const year = Calendar.getFullYear(date);

        this.setState(
            {
                month,
                year,
            },
            () => {
                this.getDaysOfMonth(year, month);
                // this.getWeeksByFirstDay();
            },
        );
    }

    // 根据月获取天数 和 本月第一天周几
    getDaysOfMonth(year, month) {
        const date = new Date();

        date.setFullYear(year);
        date.setMonth(month, 1);

        const days = new Date(year, month + 1, 0).getDate(); // 获取本月天数
        const firstDay = date.getDay(); // 获取本月第一天周几

        this.setState({
            days,
            firstDay,
        });
    }

    // 格式化每行数组
    formatDaysArr = (days, line) => {
        const {
            selectedyear,
            selectedMonth,
            selectedDay,
            currentYear,
            currentYearMonth,
            currentDay,
            year,
            month,
        } = this.state;
        const weekArr = [];

        WEEK_NAMES.forEach((day, index) => {
            // 计算日期
            const number = line * 7 + index - this.state.firstDay + 1;

            // 空白占位
            if (number <= 0) {
                weekArr.push(<span className={styles.disable}>{number + days}</span>);

                return;
            }

            if (number > days) {
                weekArr.push(<span className={styles.disable}>{number - days}</span>);

                return;
            }

            if (currentYear === year && currentYearMonth === month && number === currentDay) {
                // 当天的处理
                weekArr.push(
                    <span className={styles.currentDay} onClick={this.handleCurDay.bind(this, number)}>
                        {number}
                    </span>,
                );
            } else {
                // 选中的一天
                weekArr.push(
                    <span
                        className={`${styles.able}  ${
                            selectedyear === year && selectedMonth === month && selectedDay === number
                                ? styles.activeDay
                                : ''
                        }`}
                        onClick={this.handleCurDay.bind(this, number)}>
                        {number}
                    </span>,
                );
            }
        });

        return weekArr;
    };

    // 改变当前月
    handleChangeMonth = flag => {
        if (flag) {
            // 下一月
            if (this.state.month === 11) {
                const year = this.state.year + 1;
                const month = 0;

                this.setState(
                    {
                        year,
                        month,
                    },
                    () => {
                        this.getDaysOfMonth(year, month);
                    },
                );

                return;
            }
            const month = this.state.month + 1;

            this.setState(
                {
                    month,
                },
                () => {
                    this.getDaysOfMonth(this.state.year, month);
                },
            );
        } else {
            // 上一月
            if (this.state.month === 0) {
                const year = this.state.year - 1;
                const month = 11;

                this.setState(
                    {
                        year,
                        month,
                    },
                    () => {
                        this.getDaysOfMonth(year, month);
                    },
                );

                return;
            }
            const month = this.state.month - 1;

            this.setState(
                {
                    month,
                },
                () => {
                    this.getDaysOfMonth(this.state.year, month);
                },
            );
        }
    };

    // 点击单天事件
    handleCurDay = day => {
        this.setState(
            {
                selectedyear: this.state.year,
                selectedMonth: this.state.month,
                selectedDay: day,
            },
            () => {
                this.props.onChange(`${this.state.year}-${this.state.month + 1}-${day}`);
            },
        );
    };

    render() {
        const { days, year, month } = this.state;

        return (
            <div className={styles.dailyWraper}>
                <div className={styles.ctrl}>
                    <div className={styles.monPrevew}>
                        <span className={styles.previewInner}>
                            {year}年{month + 1}月
                        </span>
                    </div>
                    <div className={styles.prev_btn} onClick={this.handleChangeMonth.bind(this, 0)} />
                    <div className={styles.next_btn} onClick={this.handleChangeMonth.bind(this, 1)} />
                </div>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            {WEEK_NAMES.map(item => {
                                return <td key={item}>{item}</td>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {LINES.map((item, line) => {
                            return (
                                <tr key={item}>
                                    {this.formatDaysArr(days, line).map((day, index) => {
                                        return <td key={index}>{day}</td>;
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Calendar;
